module.exports = __webpack_public_path__ + "static/media/oh-snap.b40ce773.jpg";